import { OPicture } from "../Models/Pictures/Model";
// import { TFile } from "../Components/FileInput";

const pictureUtils = {

    upload: async (pictureObject: any, folderName: string, fileName?: string) => {
        const { base64, name } = pictureObject;
        return await OPicture.requestPostActivity(OPicture.Activities.UPLOAD, { base64Img: base64, filename: fileName || name, folder: folderName }).catch(error => { throw error });
    },

    // buildImageObject: (file:TFi) => {
    //     let reader = new FileReader();
    //     return new Promise((resolve, reject) => {
    //         reader.onloadend = (event) => {
    //             let fileObject: TFile = {
    //                 name: file.name,
    //                 type: file.type,
    //                 size: Math.round(file.size / 1000) + ' kB',
    //                 base64: reader.result,
    //                 file,
    //             };
    //             resolve(fileObject);
    //         }
    //         reader.readAsDataURL(file);
    //     })
    // }

}

export default pictureUtils;